
import './App.css';
import Header from './Components/Header/Header';
import Extra from './Components/Extra/Extra';
import Companies from './Components/Companies/Companies';
import Residency from './Components/Residency/Residency';
import Value from './Components/Value/Value';
import Contacts from './Components/Contacts/Contact';
import GetStarted from './Components/GetStarted/GetStarted';
function App() {
  return (
    <>
    <Header/>
    <Extra/>
    <Companies/>
    <Residency/>
    <Value/>
    <Contacts/>
    <GetStarted/>
    
    
    </>
  );
}

export default App;
